<div class="ladder-container">
	@for (pnl of conditionalPnLs$ | async; track pnl?.label) {
		@let label = pnl?.label;
		@let value = pnl?.pnl;
		<div class="ladder-condition">
			<span>{{ label }}</span>
			@if (value !== undefined && value !== null) {
				<b [ngClass]="{ profit: value >= 0, loss: value < 0 }">{{ value | number: '1.2-2' }}</b>
			}
		</div>
	}
</div>
